__turbopack_context__.v({
  "card": "psxWWG_card",
  "cardContent": "psxWWG_cardContent",
  "cardFooter": "psxWWG_cardFooter",
  "cardHeader": "psxWWG_cardHeader",
  "cardSummary": "psxWWG_cardSummary",
  "cardTitle": "psxWWG_cardTitle",
  "radiusLarge": "psxWWG_radiusLarge",
});
